import firebase from "firebase/app";
import "firebase/database";

import { firebaseConfig } from "./constants";

export const firebaseRef = firebase.initializeApp(firebaseConfig).database().ref();
